import { yupResolver } from '@hookform/resolvers/yup';
import {
  Button,
  Card, CardContent, CardDescription, CardHeader, CardTitle,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  toast,
} from 'alm-react-components';
import { confirmSignIn, fetchUserAttributes, signIn } from 'aws-amplify/auth';
import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import * as yup from 'yup';
import { ActionType, APPROUTES, CognitoResponse, constants, SET_VERIFICATION_CODE_INTERVAL, StatusCode, SubscriptionStatus } from '../../assets/constants/constants';
import { AppContext } from '../../context/AppProvider';
import { authSession, awsErrorCodeMsgToster, encrptText } from '../../lib/utils';
import { apis } from '../../services/alm';
import { otpVerification, resetOtp, tryRemaning } from '../../services/customSignin';
import { deviceDetails, getAlmToken, getSllUser, updateLanguageSetting } from '../../services/user';

const VerifyEmail = () => {

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [query] = useSearchParams();
  const attempts: any = query.get('attempts');
  const [codeError, setCodeError] = useState('');
  const [counter, setCounter] = useState(attempts == 0 ? 0 : 3);
  const [seconds, setSeconds] = useState(30);
  const [isActive, setIsActive] = useState(true);
  const [isAttempsAvailable, setIsAttempsAvailable] = useState(false)
  const { dispatch, state } = useContext(AppContext);
  const username: any = state?.user?.username;
  const localUserName: any = JSON.parse(localStorage.getItem('userValues') || '{}');
  const { type } = useParams<any>();

  useEffect(() => {
    let intervalId: any;
    if (isActive && counter > 0) {
      intervalId = setInterval(() => {
        setSeconds(prevSeconds => {
          if (prevSeconds === 0) {
            clearInterval(intervalId);
            setIsActive(false);
            return 0;
          } else {
            return prevSeconds - 1;
          }
        });
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [isActive]);

  const getAttemmpsRemainning = async () => {
    const result: any = await tryRemaning(localUserName?.username);
    setCounter(result?.data?.codeVerificationAttemptRemaining);
    if (result?.data?.codeVerificationAttemptRemaining === 0) {
      setIsAttempsAvailable(true)
    }else{
      setIsAttempsAvailable(false)
    }
  }
  useEffect(() => {
    if (type === 'account') {
      getAttemmpsRemainning();
    } else {
      if (!state.loginDetail) {
        navigate('/')
      }
    }
  }, [localUserName?.username, counter]);

  useEffect(()=>{
   const intervalId= setInterval(()=>{
      getAttemmpsRemainning()
    },SET_VERIFICATION_CODE_INTERVAL)
    return ()=>{
      clearInterval(intervalId)
    }
  },[isAttempsAvailable])
  async function onhandleSubmit(values: any) {

    try {

      dispatch({ type: ActionType.SET_LOADING, payload: true });
      const finalValues: any = {
        ...values,
        username: username ? username : localUserName?.username,
        stage: 2,
      };
      // putAppCuesData({
      //   eventName:appcues_event.signUp,
      //   userId: state.user?.username || "",
      //   refferal_code:"",
      //   event_timestamp: new Date().toISOString(),});

      if (type === 'signin') {
        confirmSignIn({ challengeResponse: values?.verificationCode }).then((res: any) => {
          if (res.isSignedIn) {
            if (res.nextStep.signInStep === CognitoResponse.done) {
              doLogin()
            }
          }
        })
          .catch((error) => {
            console.log('error------>', error);
            const { name }: { name: any | undefined, message: any | undefined } = error;
            awsErrorCodeMsgToster(name, false)
          })
      } else {
        const response: any = await otpVerification(finalValues);
        if (response?.status === StatusCode.SUCCESS) {
          try {
            await signIn({
              username: localUserName?.username,
              password: encrptText(localUserName?.password),
            });
            const accessToken = await authSession();
            await fetchUserAttributes().then(() => {
              localStorage.setItem('token', accessToken ? accessToken : '');
              dispatch({ type: ActionType.IS_AUTH, payload: true });
            });
            navigate(APPROUTES.profile);
          } catch (error) {
            console.error(
              error,
              "Oops! username or password invalid or already active session"
            );
            toast({
              description: 'Oops! username or password invalid or already active session',
              variant: 'error',
            });
          }
        } else {
          const result: any = await tryRemaning(username ? username : localUserName?.username);
          setCounter(result?.data?.codeVerificationAttemptRemaining);
          if (response?.error?.code == 'UserNotFoundException') {
            setCodeError(t('Validations.userNotFoundError'));
          } else if (response?.error?.code == 'ExpiredCodeException') {
            setCodeError(t('Validations.codeExpiredError'));
          } else if (response?.error?.code == 'CodeMismatchException') {
            setCodeError(t('Validations.invalidVerification'));
          } else if (response?.error?.code == 'LimitExceededException') {
            setCodeError(t('Validations.attemptLimitError'));
          } else if (response?.error?.code == 'codeVerificationLocked') {
            setCodeError(t('Validations.attemptLimitError'));
          } else if (response?.error?.code == 'Internal server error') {
            setCodeError(t('Validations.internalError'));
          } else if (response?.error?.code == 'NotAuthorizedException') {
            setCodeError(t('Validations.internalError'));
          } else if (response?.code == 'VerificationCodeExpired') {
            setCodeError(t('Validations.errorCodeExpired'));
          } else if (response?.code == 'UnknownErrorOccured') {
            setCodeError(t('ErrorType.invalidRequest'));
          } else if (response?.status === StatusCode.ERR_BAD_REQUEST) {
            toast({
              description: t('Validations.invalidVerificationCode'),
              variant: 'error',
            });
          }
        }
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTimeout(() => {
        dispatch({ type: ActionType.SET_LOADING, payload: false });
      }, 3000);
    }
  }
  const doLogin = async () => {
    const language = localStorage.getItem("locale") || constants.dutchLocale;
    const languageCode = localStorage.getItem("i18nextLng") || constants.dutchCode;
    const accessToken = await authSession();
    fetchUserAttributes().then(async (userAttributes: any) => {
      //Set token
      localStorage.setItem('token', accessToken ? accessToken : '');
      await deviceDetails(constants.login);
      await getSllUser(userAttributes.email).then((res: any) => {
        const data = res.data;
        dispatch({ type: ActionType.IS_AUTH, payload: true });
        if (res.status === StatusCode.SUCCESS) {
          if (data.subscriptionStatus === SubscriptionStatus.active || data.subscriptionStatus === SubscriptionStatus.trial
          ) {
            if (data.fullName) {
              getAlmToken().then(async (learnerRes: any) => {
                if (learnerRes.status === StatusCode.SUCCESS) {
                  localStorage.setItem('access_token', learnerRes.data.access_token ? learnerRes.data.access_token : '');
                  localStorage.setItem('refresh_token', learnerRes.data.refresh_token ? learnerRes.data.refresh_token : '');
                  await apis.checkAlmUser().then(async (res: any) => {
                    const userLanguage = res?.data?.attributes?.uiLocale;
                    if (!userLanguage || userLanguage !== language) {
                      localStorage.setItem('i18nextLng', languageCode);
                      localStorage.setItem('locale', language);
                      await apis.updateUserContent(learnerRes?.data?.user_id, language);
                      await updateLanguageSetting(language);
                      i18n.changeLanguage(languageCode);
                    }
                    navigate(APPROUTES.home);
                  });
                }
                else {
                  navigate("/");
                }
              }).catch(() => {
                dispatch({ type: ActionType.SET_LOADING, payload: false });
              });
            } else {
              navigate(APPROUTES.profile);
            }
          }
          else if (
            data.subscriptionStatus === SubscriptionStatus.pending || data.subscriptionStatus === SubscriptionStatus.canceled || data.subscriptionStatus === SubscriptionStatus.trialOver
          ) {
            if (data.subscriptionStatus === SubscriptionStatus.trialOver) {
              navigate(APPROUTES.selectCurrency);
            } else {
              navigate(APPROUTES.selectMembership);
            }
          }
        }
      });
      dispatch({ type: ActionType.SET_LOADING, payload: false });
    });
  };
  const schema = yup
    .object({
      verificationCode: yup
        .string()
        .required(t('Validations.verificationRequired'))
        .matches(/^[0-9]+$/, t('Validations.digitsRequired'))
        .min(6, t('Validations.min&MaxDigits'))
        .max(6, t('Validations.min&MaxDigits')),
    })
    .required();
  const form = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      verificationCode: '',
    },
  });
  const onResendOtp = async () => {
    if (type === 'signin') {
      const params = {
        username: state.loginDetail?.username,
        password: state.loginDetail?.password
      };
      await signIn(params);
    } else {
      if (username) {
        await resetOtp({ username });
      } else {
        await resetOtp({ username: localUserName?.username });
      }
    }
    setIsActive(true);
    setSeconds(30);
  };
  return (
    <>
      <div className=" md:min-w-[486px] md:max-w-[486px] px-4 md:mx-auto">
        <Card className="text-base border-0 bg-transparent">
          <CardHeader className="block text-left px-0">
            <CardTitle className="text-3xl font-light font-barlowLight">
              <span dangerouslySetInnerHTML={{ __html: t('SignUp.verifyEmail') }} />
            </CardTitle>
            <CardDescription className=" text-base font-normal dark:text-white py-4 text-balance">
              <span dangerouslySetInnerHTML={{ __html: t('SignUp.codeDesc') }} />
            </CardDescription>
          </CardHeader>
          <CardContent className="px-0">
            <Form {...form}>
              <form onSubmit={form.handleSubmit(onhandleSubmit)} className="">
                <div className="grid w-full items-center gap-4 mb-6">
                  <div className="flex flex-col space-y-1.5 text-base">
                    <FormField
                      control={form.control}
                      name="verificationCode"
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel className="text-xs tracking-wider">
                            <span dangerouslySetInnerHTML={{ __html: t('SignUp.verificationCode') }} />
                          </FormLabel>
                          <FormControl>
                            <Input
                              placeholder={t('PlaceHolder.enterVerificationCode')}
                              {...field}
                              className="h-auto py-4 text-base pe-16 opacity-100"
                            />
                          </FormControl>
                          <FormMessage><span dangerouslySetInnerHTML={{ __html: codeError }} /></FormMessage>
                        </FormItem>
                      )}
                    />
                  </div>
                </div>
                <div className="flex justify-between ">
                  {counter === 0 && <p dangerouslySetInnerHTML={{ __html: t('Validations.msgTryAfterSometime'), }} />}
                  {counter !== 0 && (
                    <p
                      style={{
                        color: seconds < 30 && seconds > 0 ? '#adb3b5' : '',
                      }}
                      className={
                        seconds < 30 && seconds > 0 ? 'cursor-not-allowed	' : 'cursor-pointer'
                      }
                      onClick={() => {
                        seconds === 30 || seconds === 0 ? onResendOtp() : '';
                      }}
                      dangerouslySetInnerHTML={{
                        __html: t("PlaceHolder.resendVerificationCode"),
                      }}
                    >
                    </p>
                  )}
                  {isActive && counter > 0 && <p>{seconds}s</p>}
                </div>
                <Button
                  disabled={counter === 0 ? true : false}
                  className="w-full h-auto py-2 text-base font-opensansSemiBold mt-6 mb-4"
                >
                  <span dangerouslySetInnerHTML={{ __html: t("Common.continue") }} />
                </Button>
              </form>
            </Form>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default VerifyEmail;
